(function () {
  'use strict';

  /**
   * <buy-button-proxy>
   *
   * Wraps a visible <button> that stands in for the theme's real,
   * functionally-active submit button (which stays hidden — visually and
   * from assistive tech — inside the "Form" block; see buy-buttons.liquid).
   *
   * Clicking the proxy triggers a native .click() on the real button, so
   * the entire existing <product-form> add-to-cart flow runs completely
   * unmodified — no theme.js changes required.
   *
   * A MutationObserver mirrors the real button's loading/disabled/success
   * state and its text label onto the proxy. It deliberately never touches
   * `[data-price-wrapper]` content: the price already updates on both
   * buttons independently and simultaneously via the theme's existing
   * broadcast (product-info's updateProductPrices, and
   * assets/bundle-offers.js's toggleSaleClasses for bundle selection).
   * Mirroring it here too would be a second, competing update path.
   */
  customElements.get('buy-button-proxy') ||
    customElements.define(
      'buy-button-proxy',
      class extends HTMLElement {
        connectedCallback() {
          this.realButton = document.getElementById(this.dataset.realButtonId);
          this.button = this.querySelector('[data-buy-button-proxy]');

          if (!this.realButton || !this.button) return;

          this.boundClick = this.handleClick.bind(this);
          this.button.addEventListener('click', this.boundClick);

          this.sync();

          this.observer = new MutationObserver(() => this.sync());
          this.observer.observe(this.realButton, {
            attributes: true,
            attributeFilter: ['disabled', 'class'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.boundClick);
          this.observer?.disconnect();
        }

        handleClick() {
          if (!this.realButton || this.realButton.hasAttribute('disabled')) return;
          this.realButton.click();
        }

        sync() {
          const isDisabled = this.realButton.hasAttribute('disabled');
          const isBusy = this.realButton.classList.contains('is-loading');
          const isSuccess = this.realButton.classList.contains('is-success');

          this.button.toggleAttribute('disabled', isDisabled);
          this.button.setAttribute('aria-disabled', String(isDisabled));
          this.button.setAttribute('aria-busy', String(isBusy));
          this.button.classList.toggle('is-loading', isBusy);
          this.button.classList.toggle('is-success', isSuccess);

          const realLabel = this.realButton.querySelector('[data-add-to-cart-label]');
          const proxyLabel = this.button.querySelector('[data-add-to-cart-label]');

          if (realLabel && proxyLabel && realLabel.textContent !== proxyLabel.textContent) {
            proxyLabel.textContent = realLabel.textContent;
          }
        }
      }
    );
})();
